import React, { useState, useEffect } from 'react';
import Application from './Application';
import { Grid, useMediaQuery, useTheme, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { UPDATE_SCHOOL } from 'graphql/student_college';
import { useMutation } from '@apollo/react-hooks';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import FilterListIcon from '@material-ui/icons/FilterList';
import Dialog from '@material-ui/core/Dialog';
import { useSelector } from 'react-redux';
import Spin from 'components/common/Spin';
import { filter, isEmpty, sortBy } from 'lodash';
import Filter from './Filter';
import SortBy from './Sort';
import PRODUCTS from 'constant/product-types';

const PRODUCTS_LOOKUP = PRODUCTS.reduce((memo, i) => {
  memo[i.value] = i.label;
  return memo;
}, {});

const useStyles = makeStyles(() => ({
  modal: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
    },
  },
}));

const Applications = (props) => {
  const classes = useStyles();
  const [updateSchool] = useMutation(UPDATE_SCHOOL);
  const user = useSelector((s) => s.user.user);
  const [applications, setapplications] = useState(props.applications);
  const [filters, setFilter] = useState({});
  const [sortParam, setsortParam] = useState('app_deadline');
  const [showModal, setShowModal] = useState(false);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    let filteredVal = filter(props.applications, filters);
    let sortedVal = isEmpty(filters)
      ? sortBy(props.applications, [sortParam])
      : sortBy(filteredVal, [sortParam]);

    if (isEmpty(filters)) {
      setapplications(sortedVal);
    } else setapplications(sortedVal);
  }, [filters, sortParam]);

  useEffect(() => {
    setapplications(props.applications);
  }, [props.applications]);

  const onStatusChange = (val, school) => {
    window.analytics.track(`Application status changed`, {
      ...school,
      status: val,
      user,
      product: PRODUCTS_LOOKUP[props.student.product_type],
    });
    updateSchool({
      variables: {
        id: school.id,
        input: {
          status: val,
        },
      },
    });
  };

  const onAdmissionTypeChange = (val, school) => {
    updateSchool({
      variables: {
        id: school.id,
        input: {
          admission_type: val,
        },
      },
    });
  };

  const onPlatformChange = (val, school) => {
    updateSchool({
      variables: {
        id: school.id,
        input: {
          app_platform: val,
        },
      },
    });
  };

  const onProgressChange = (e, value, school) => {
    updateSchool({
      variables: {
        id: school.id,
        input: {
          progress: value,
        },
      },
    });
  };

  return (
    <Box marginTop={5}>
      <Grid container spacing={4}>
        <Box
          component={Grid}
          item
          sm={4}
          md={3}
          display={{ xs: 'none', sm: 'block' }}
        >
          <Filter matches={matches} filters={filters} setFilter={setFilter} />
        </Box>
        <Grid item xs={12} sm={8} md={7}>
          <Box display="flex" alignItems="baseline">
            <Box display={{ xs: 'block', sm: 'none' }}>
              <IconButton onClick={() => setShowModal(true)}>
                <FilterListIcon />
              </IconButton>
            </Box>
            <SortBy sortParam={sortParam} setsortParam={setsortParam} />
          </Box>
          {applications ? (
            applications?.map(
              (application, index) =>
                application.category &&
                application.category !== 'student' && (
                  <Grid item xs={12} key={index}>
                    <Application
                      matches={matches}
                      student={props.student}
                      user={user}
                      data={application}
                      onStatusChange={onStatusChange}
                      onAdmissionTypeChange={onAdmissionTypeChange}
                      onPlatformChange={onPlatformChange}
                      onProgressChange={onProgressChange}
                    />
                  </Grid>
                ),
            )
          ) : (
            <Spin spinning linear />
          )}
        </Grid>
      </Grid>
      {showModal && (
        <Dialog fullScreen open onClose={() => setShowModal(false)}>
          <Box padding={3} className={classes.modal}>
            <Filter matches={matches} filters={filters} setFilter={setFilter} />
            <Box>
              <Button
                fullWidth
                onClick={() => setShowModal(false)}
                size="large"
                variant="contained"
                color="primary"
              >
                Show results
              </Button>
            </Box>
          </Box>
        </Dialog>
      )}
    </Box>
  );
};

export default Applications;
